import { action } from 'app/actions';

export const GET_EVALUATIONS = 'reportApplication/GET_EVALUATIONS';
export const getEvaluations = payload => action(GET_EVALUATIONS, { payload });

export const GET_GROUPS = 'reportApplication/GET_GROUPS';
export const getGroups = payload => action(GET_GROUPS, { payload });

export const GET_FILTERS_REPORTS = 'reportApplication/GET_FILTERS_REPORTS';
export const getFilterReports = payload => action(GET_FILTERS_REPORTS, { payload });

export const UPDATE_EVALUATION_CRITERIA = 'reportApplication/UPDATE_EVALUATION_CRITERIA';
export const updateEvaluationCriteria = payload => action(UPDATE_EVALUATION_CRITERIA, { payload });

export const GET_EVALUATION_CRITERIA = 'reportApplication/GET_EVALUATION_CRITERIA';
export const getEvaluationCriteria = payload => action(GET_EVALUATION_CRITERIA, { payload });
